import React from "react";
import "../../../AllComponentCSS.css";

const CSS_Home = () => {
  return (
    <div className="tutorial-container">
      <h1 className="tutorial-title">🌐 CSS Tutorial</h1>

      <p className="tutorial-intro">
        CSS (Cascading Style Sheets) is used to style and layout web pages — for
        example, to change fonts, colors, spacing, and positioning. While HTML
        structures content, CSS makes it visually attractive.
      </p>

      <div
        style={{
          background: "linear-gradient(135deg, #d1fae5, #bbf7d0)",
          padding: "1rem",
          borderRadius: "12px",
          marginBottom: "2rem",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: "#166534", marginBottom: "0.5rem" }}>
          ✨ Why Learn CSS?
        </h2>
        <p style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
          CSS makes your websites beautiful, responsive, and interactive.
          Combined with HTML and JavaScript, it forms the core of front-end web
          development.
        </p>
      </div>

      {/* Key Topics */}
      <div className="tutorial-section">
        <h2 className="section-title">📘 CSS Tutorial Topics</h2>
        <ul className="tutorial-list">
          <li>
            <a href="/css/syntax" className="learn-more">
              CSS Syntax
            </a>{" "}
            – Learn how selectors and declarations work.
          </li>
          <li>
            <a href="/css/howto" className="learn-more">
              CSS How To
            </a>{" "}
            – Different ways to apply CSS (inline, internal, external).
          </li>
          <li>
            <a href="/css/comments" className="learn-more">
              CSS Comments
            </a>{" "}
            – Add notes in your CSS for better readability.
          </li>
          <li>
            <a href="/css/colors" className="learn-more">
              CSS Colors
            </a>{" "}
            – Style elements with color names, HEX, RGB, and gradients.
          </li>
          <li>
            <a href="/css/errors" className="learn-more">
              CSS Errors
            </a>{" "}
            – Common mistakes and how to debug them.
          </li>
        </ul>
      </div>

      {/* Example Preview */}
      <div className="tutorial-section">
        <h2 className="section-title">👨‍💻 Example</h2>
        <p>
          Here’s a simple CSS example that changes the text color and background
          of a heading:
        </p>
        <pre className="code-block" style={{ marginBottom: "1rem" }}>{`h1 {
  color: white;
  background-color: #1f7a39;
  padding: 10px;
  text-align: center;
}`}</pre>

        <div
          style={{
            backgroundColor: "#1f7a39",
            color: "white",
            padding: "10px",
            textAlign: "center",
            borderRadius: "8px",
          }}
        >
          This is a styled heading
        </div>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">🚀 Next Steps</h2>
        <p>
          Start learning step by step with{" "}
          <a href="/css/syntax" className="learn-more">
            CSS Syntax
          </a>{" "}
          to understand the foundation of how CSS rules are written.
        </p>
      </div>
    </div>
  );
};

export default CSS_Home;
